import i18n from 'i18next';
import i18nextHttpBackend, { HttpBackendOptions } from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { AEM_MARKET_CONFIG, DEFAULT_MARKET_LANGUAGES, MarketIdentifier } from '~/app/market-config';
import { windowAvailable } from '~/utils/client-detection';

let lng = 'de';
const availableMarkets = Object.keys(DEFAULT_MARKET_LANGUAGES);
const market = windowAvailable() ? new URLSearchParams(window?.location.search).get('market') : undefined;
if (AEM_MARKET_CONFIG.language) {
	lng = AEM_MARKET_CONFIG.language;
} else if (market && availableMarkets.includes(market)) {
	lng = DEFAULT_MARKET_LANGUAGES[market as MarketIdentifier];
}

const I18N_URL = process.env.IS_VITE_DEV ? '/i18n' : 'https://d1p8elq7q5x0x6.cloudfront.net/ngc/ngc-translations';

export default i18n
	.use(i18nextHttpBackend)
	.use(initReactI18next)
	.init<HttpBackendOptions>({
		react: {
			useSuspense: false,
		},
		backend: {
			loadPath: `${I18N_URL}/{{lng}}.json`,
		},
		lng,
		fallbackLng: 'en',
		interpolation: {
			escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
		},
	});

export function updateLanguage(language: string) {
	i18n.use(i18nextHttpBackend)
		.use(initReactI18next)
		.init<HttpBackendOptions>({
			react: {
				useSuspense: false,
			},
			backend: {
				loadPath: `${I18N_URL}/${language.toLowerCase()}.json`,
			},
			lng,
			fallbackLng: 'en',
			interpolation: {
				escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
			},
		});
}
